import './views/global'
import './views/spree/products/index'
import './views/spree/products/show'
import './api/base'
import './api/recommendations'

export { default as Analytics } from './Analytics'
export { default as DeseretBookCMS } from './DeseretBookCMS'
export { default as Logger } from './Logger'


/**
 * Formats errors for better logging results.
 * @param {*} errors - Error response
 * @returns {string} formatted error message
 */
const errorsToString = (errors = '') => {
  if (typeof errors === 'string') {
    return errors
  }

  if (Array.isArray(errors)) {
    return errors
      .map(error => errorsToString(error))
      .filter(Boolean)
      .join(', ')
  }

  if (typeof errors === 'object') {
    return Object.values(errors)
      .map(error => errorsToString(error))
      .filter(Boolean)
      .join(', ')
  }

  return (String(errors))
}

/**
 * Formats an error message for better readability.
 * @param {*} message - Error Message
 * @param {*} errors - API errors response
 * @returns {string} Pretty error message
 */
export const formatErrorMessage = (message = '', errors = '') => [errorsToString(message), errorsToString(errors)].filter(Boolean).join(': ')
